import { Button, styled } from '@mui/material'

const ActionButton = styled(Button)({
    border: "none",
    borderRadius: "0.7rem",
    padding: "0.75rem",
})

export default ActionButton